import { render, staticRenderFns } from "./ManageFilterGroup.vue?vue&type=template&id=56b47dba"
import script from "./ManageFilterGroup.vue?vue&type=script&lang=js"
export * from "./ManageFilterGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports